<template>
  <v-container>
    <i18n tag="p" path="account_verification.message">
      <strong class="body-2">{{ account.email }}</strong>
    </i18n>
    <p class="title mt-5">{{ $tf('account_verification.other_account') }}</p>
    <button
      class="account-selector"
      @click="onSelectAccount">
      <avatar
        :account="account"
        :size="20"
      />
      <span class="body-2">{{ account.email }}</span>
      <v-icon>keyboard_arrow_down</v-icon>
    </button>
  </v-container>
</template>

<script>
  export default {
    name: 'DialogAccountVerification',
    computed: {
      account () {
        return this.$store.state.session.account
      }
    },
    methods: {
      async onSelectAccount () {
        await this.$store.dispatch('session/intendedDestination', this.$route.fullPath)
        this.goToAuth('login', { 'default_login_methods': this.$whitelabel.loginMethods.join(' ') })
      },
      goToAuth (url, params) {
        url = this.$config.ssoUrl + url + '?hl=' + this.$store.state.session.locale
        if (this.$whitelabel.url) url = url + '&wl=' + this.$whitelabel.domain
        if (params) {
          Object.keys(params).forEach(param => {
            url = url + '&' + param + '=' + encodeURIComponent(params[param])
          })
        }
        this.$store.dispatch('session/destroySession').then(() => {
          window.location = url
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .account-selector {
    display: flex;
    align-items: center;
    border: 1px solid #dadce0;
    border-radius: 15px;
    padding: 5px;
    cursor: pointer;
    letter-spacing: 0.25px;
    margin: 0 auto;

    &:hover {
      background: rgba(60, 64, 67, 0.039);
    }

    span {
      margin: 0 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogAccountVerification.vue